module.exports = __webpack_public_path__ + "static/media/jeremy-dickey.86688047.jpg";